import TourModeScreenWebsocket from "./TourModeScreenWebsocket";


export default class TourUnifiedController {
  constructor({ model, socket }) {
    this.model = model;
    model.tourStreamController = this;

    this.cameraController = model.tourModeController;
    this.screenController = new TourModeScreenWebsocket({ model, socket }); // Starts with audio false
  }

  /**
   * Cleanup all tour mode streams (camera and screen)
   * Returns a Promise that resolves when all streams are closed
   * This should be called before switching to meeting mode
   */
  cleanupAllStreams() {
    return new Promise(async (resolve) => {
      try {
        // Cleanup both controllers in parallel
        const cleanupPromises = [
          this.cameraController.cleanupStreams(),
          this.screenController.cleanupStreams()
        ];
        
        await Promise.all(cleanupPromises);
        
        resolve();
      } catch (error) {
        console.error("Error during tour stream cleanup:", error);
        // Resolve anyway to not block meeting mode start
        resolve();
      }
    });
  }
}